"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebContractGetCartResponseSchema = exports.CartItemsSchema = exports.WebContractCartItemIdPathParamsSchema = exports.WebContractUpdateCartItemRequestSchema = exports.WebContractAddCartItemRequestSchema = exports.WebContractCreateCartRequestSchema = exports.PromotionSchema = exports.ConditionTypeSchema = exports.DiscountTypeSchema = void 0;
const zod_1 = require("zod");
const shared_1 = require("../../../shared");
const CartItemSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    cartId: zod_1.z.string(),
    productId: zod_1.z.string(),
    quantity: zod_1.z.number().int(),
});
exports.DiscountTypeSchema = zod_1.z.enum(['PERCENTAGE', 'FIXED_AMOUNT']);
exports.ConditionTypeSchema = zod_1.z.enum(['BIRTHDAY', 'FIRST_ORDER', 'NONE']);
exports.PromotionSchema = zod_1.z.object({
    type: exports.DiscountTypeSchema,
    conditionType: exports.ConditionTypeSchema,
    id: zod_1.z.string().uuid(),
    createdAt: zod_1.z.coerce.date(),
    updatedAt: zod_1.z.coerce.date(),
    name: zod_1.z.string(),
    description: zod_1.z.string().nullable(),
    startDate: zod_1.z.coerce.date(),
    endDate: zod_1.z.coerce.date(),
    quota: zod_1.z.number().int(),
    isActive: zod_1.z.boolean(),
    value: zod_1.z.number(),
    minimumSpend: zod_1.z.number(),
});
exports.WebContractCreateCartRequestSchema = zod_1.z.object({
    productId: zod_1.z.string(),
    quantity: zod_1.z.number(),
});
exports.WebContractAddCartItemRequestSchema = zod_1.z.object({
    productId: zod_1.z.string(),
    quantity: zod_1.z.number(),
});
exports.WebContractUpdateCartItemRequestSchema = zod_1.z.object({ quantity: zod_1.z.number() });
exports.WebContractCartItemIdPathParamsSchema = zod_1.z.object({ cartItemId: zod_1.z.string() });
exports.CartItemsSchema = CartItemSchema
    .pick({
    id: true,
    quantity: true,
}).extend({
    unitPrice: shared_1.PositiveFloatSchema,
    discountPrice: shared_1.PositiveFloatSchema.nullable(),
    totalPrice: shared_1.PositiveFloatSchema,
    effectiveUnitPrice: shared_1.PositiveFloatSchema,
    effectiveTotalPrice: shared_1.PositiveFloatSchema,
    discountAmount: shared_1.NonNegativeFloatSchema,
    product: zod_1.z.object({
        id: zod_1.z.string(),
        image: zod_1.z.string(),
        name: zod_1.z.string(),
        stock: zod_1.z.number().int().nonnegative(),
    }),
});
exports.WebContractGetCartResponseSchema = zod_1.z.object({
    cart: zod_1.z.object({
        id: zod_1.z.string(),
        type: zod_1.z.enum(['GUEST', 'MEMBER']),
        name: zod_1.z.string(),
        phone: zod_1.z.string(),
        email: zod_1.z.string(),
        itemCount: shared_1.NonNegativeFloatSchema,
        skuCount: shared_1.NonNegativeFloatSchema,
        beforeDiscount: shared_1.NonNegativeFloatSchema,
        memberDiscount: shared_1.NonNegativeFloatSchema,
        promotionDiscount: shared_1.NonNegativeFloatSchema,
        afterDiscount: shared_1.NonNegativeFloatSchema,
        shippingFee: shared_1.NonNegativeFloatSchema,
        finalPrice: shared_1.NonNegativeFloatSchema,
        cartItems: exports.CartItemsSchema.array(),
    }),
    promotions: exports.PromotionSchema.extend({ appliedAmount: zod_1.z.number() }).array().default([]),
});
